module.exports = __webpack_public_path__ + "img/valuationbanner2.ebf5bacb.png";